import { useEffect, useState } from "react";
//---------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyFormData } from "src/components/common/functions";
//---------------------------------------------------------------------
export default function SettingForm({
    keyword, 
    closeIt, 
    id, 
    setRenderSwitch
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [curSettings, setSettings] = useState([]);
    const [curMode, setMode] = useState("");
    const [curTrainingName, setCurTraining] = useState("");
    const [passScore, setPassScore] = useState("");
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("fileId", id);
            //-------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("common/getJSONData.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------------------------------
            setSettings(res.data.questions);
            setMode(res.data.mode);
            setCurTraining(res.data.name);
            setPassScore(res.data.passScore);
        }
        if(id)getData();
        return () => {isMounted = false;}
    },[id])
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"900px"}
            maxWidth = {"100%"}
            onSave = {async() => {
                const formData = new MyFormData();
                formData.append("fileId", id);
                formData.append("trainingName", curTrainingName);
                formData.append("data", JSON.stringify({name: curTrainingName, mode: curMode, questions: curSettings, passScore: passScore}));
                //-------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("training/training.php", formData);
                setShowLoader(false);
                if(!res) return;
                //-------------------------------------------------------------
                closeIt();
                setRenderSwitch(s => !s);
            }}
        >
            <div className = "my-2">
                <sapn className = "blk">
                    <span className = "font-weight-bold mr-3">Training Name:</span>
                    <input required className = "inline form-control mr-3" value = {curTrainingName} onChange = {e => {
                        setCurTraining(e.currentTarget.value);
                    }}/>
                </sapn>
                <sapn className = "blk">
                    <span className = "font-weight-bold mr-3">Training Mode:</span>
                    <select required className = "inline form-control mr-3" value = {curMode} onChange = {e => {
                        setMode(e.currentTarget.value);
                    }}>
                        <option value = "">Select</option>
                        <option>Practice</option>
                        <option>Quiz</option>
                    </select>
                </sapn>
                <sapn className = "blk">
                    <span className = "font-weight-bold mr-3">Pass Score:</span>
                    <input
                        type = "number"
                        step = "0.5"
                        min = "0"
                        max = {curSettings.length}
                        required
                        className = "inline form-control mr-3"
                        value = {passScore}
                        onChange = {e => {
                            setPassScore(e.currentTarget.value);
                        }}
                    />
                </sapn>
            </div>
            {curSettings.map((setting, settingIndex) => 
            <div key = {settingIndex} className = "border rounded p-3 my-3">
                <div className = "mb-3">
                    <div className = "font-weight-bold mr-3">Question Title:</div>
                    <textarea
                        required
                        className = "form-control"
                        style = {{minWidth: "100%"}}
                        value = {setting.name}
                        onChange = {e => {
                            setSettings([
                                ...curSettings.slice(0, settingIndex), 
                                {...setting, name: e.currentTarget.value},
                                ...curSettings.slice(settingIndex + 1)
                            ]);
                        }}
                    />
                </div>
                <div className = "mb-3">
                    <span className = "mr-3">Multiple Choice</span>
                    <input style = {{width: 30, height: 30}} type = "checkbox" checked = {setting.multi} onChange = {e => {
                        setSettings([
                            ...curSettings.slice(0, settingIndex), 
                            {...setting, 
                                multi: e.currentTarget.checked, 
                                options: setting.options.map(optx => ({...optx, answer: false})),
                                signleAnswer: ""
                            },
                            ...curSettings.slice(settingIndex + 1)
                        ]);
                    }}/>
                </div>
                <div>
                    <div className = "border rounded p-3 my-2">
                        <div className = "font-weight-bold">Question Options:</div>
                        {setting.options.map((opt, optIndex) => 
                        <div key = {optIndex} className = "my-2 p-2 border rounded">
                            <span className = "blk">
                                <span className = "mr-3">name</span>
                                <input
                                    className = "inline form-control mr-3"
                                    value = {opt.name}
                                    onChange = {e => {
                                        setSettings([
                                            ...curSettings.slice(0, settingIndex), 
                                            {
                                                ...setting,
                                                options: [...setting.options.slice(0, optIndex), {...opt, name: e.currentTarget.value} , ...setting.options.slice(optIndex + 1)]
                                            },
                                            ...curSettings.slice(settingIndex + 1)
                                        ]);
                                    }}
                                />
                            </span>
                            <span className = "blk">
                                <span className = "mr-3">comment</span>
                                <input
                                    className = "inline form-control mr-3"
                                    value = {opt.comment}
                                    onChange = {e => {
                                        setSettings([
                                            ...curSettings.slice(0, settingIndex), 
                                            {
                                                ...setting,
                                                options: [...setting.options.slice(0, optIndex), {...opt, comment: e.currentTarget.value} , ...setting.options.slice(optIndex + 1)]
                                            },
                                            ...curSettings.slice(settingIndex + 1)
                                        ]);
                                    }}
                                />
                            </span>
                            <span className = "blk">
                                <label htmlFor = {optIndex + "answer"} className = "mr-3 d-inline">answer</label>
                                <input 
                                    id = {optIndex + "answer"}
                                    name = {setting.name} 
                                    type = {setting.multi?"checkbox":"radio"} 
                                    className = "mr-3" 
                                    style = {{width: 30, height: 30}} 
                                    checked = {opt.answer || false} 
                                    value = {opt.name} 
                                    onChange = {e => {
                                        setSettings([
                                            ...curSettings.slice(0, settingIndex), 
                                            {
                                                ...setting,
                                                options: [...setting.options.slice(0, optIndex).map(opt0 => ({...opt0, answer: setting.multi?opt0.answer:false})), {...opt, 
                                                    answer: setting.multi?e.currentTarget.checked:true
                                                } , ...setting.options.slice(optIndex + 1).map(opt1 => ({...opt1, answer: setting.multi?opt1.answer:false}))],
                                                signleAnswer: e.currentTarget.value
                                            },
                                            ...curSettings.slice(settingIndex + 1)
                                        ]);
                                    }}
                                />
                            </span>
                            <span className = "btn btn-danger" onClick = {() => {
                            setSettings([
                                ...curSettings.slice(0, settingIndex),
                                {
                                    ...setting,
                                    options: [...setting.options.slice(0, optIndex), ...setting.options.slice(optIndex + 1)]
                                },
                                ...curSettings.slice(settingIndex + 1)
                            ]);
                        }}>Delete</span>
                        </div>)}
                        <span className = "btn btn-primary mr-3" onClick = {() => {
                            setSettings([
                                ...curSettings.slice(0, settingIndex), 
                                {
                                    ...setting,
                                    options: [...setting.options, {name: "", comment: ""}]
                                },
                                ...curSettings.slice(settingIndex + 1)
                            ]);
                        }}>Add Option</span>
                    </div>
                    <span className = "btn btn-danger" onClick = {() => {
                        setSettings([
                            ...curSettings.slice(0, settingIndex),
                            ...curSettings.slice(settingIndex + 1)
                        ]);
                    }}>Delete Question</span>
                </div>
            </div>
            )}
            <div className = "my-3">
                <span className = "btn btn-primary" onClick = {() => {setSettings([
                    ...curSettings, {name: "", hashKey: Math.random().toString(36).substring(2), options: []}
                ]);
                }}>Add Question</span>
            </div>
        </Modal>
    )
}